import {useMediaQuery} from 'react-responsive';

/**
 * 디바이스 타입 가져오기
 * @returns 디바이스 타입 ('pc' | 'tablet' | 'mobile')
 * @public
 */
export const getDevice = () => {
  const isPc = useMediaQuery({
    query: '(min-width:1024px)',
  });
  const isTablet = useMediaQuery({
    query: '(min-width:768px) and (max-width:1023px)',
  });
  const isMobile = useMediaQuery({
    query: '(max-width:767px)',
  });

  if (isPc) {
    return 'pc';
  } else if (isTablet) {
    return 'tablet';
  } else if (isMobile) {
    return 'mobile';
  }
};
